import { render, staticRenderFns } from "./_spadeGaming.vue?vue&type=template&id=11809297&lang=pug&"
import script from "./_spadeGaming.vue?vue&type=script&lang=js&"
export * from "./_spadeGaming.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports